import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import {
  Table,
  Card,
  Tag,
  Space,
  Typography,
  Input,
} from "antd"
import {
  FileTextOutlined,
  SearchOutlined,
} from "@ant-design/icons"
import NumberFormat from "react-number-format"
import { getEngInvoices } from "store/actions"
import { getCurrentUser } from "helpers/service_helper"

const { Text } = Typography

const columns = [
  {
    title: "مبلغ (ریال)",
    dataIndex: "amount",
    key: "amount",
    render: value => (
      <Text strong style={{ color: "#52c41a" }}>
        <NumberFormat displayType="text" value={value} thousandSeparator />
      </Text>
    ),
  },
  {
    title: "تاریخ انجام و تحویل به واحدگاز",
    dataIndex: "solarDateDeliverOffice",
    key: "solarDateDeliverOffice",
  },
  {
    title: "مجری",
    dataIndex: "executorName",
    key: "executorName",
    render: name => name ? <Tag color="blue">{name}</Tag> : "-",
  },
  {
    title: "مربوط به پرونده",
    dataIndex: "fileNumber",
    key: "fileNumber",
    render: value => value ? <Tag color="geekblue">{value}</Tag> : "-",
  },
  {
    title: "توضیحات",
    dataIndex: "transactionDes",
    key: "transactionDes",
    render: val => <Text type="secondary">{val || "-"}</Text>,
  },
]

const InvoiceEngList = props => {
  const { lstInvoices, loading } = props
  const [search, setSearch] = useState("")

  useEffect(() => {
    props.onGetInvoices(getCurrentUser().sid)
  }, [])

  const filtered = (lstInvoices || []).filter(row =>
    Object.values(row).some(val =>
      String(val ?? "").toLowerCase().includes(search.toLowerCase())
    )
  )

  return (
    <Card
      bordered={false}
      style={{ borderRadius: 16, boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}
      title={
        <Space>
          <FileTextOutlined style={{ color: "#1890ff" }} />
          <span>فاکتورهای کارشناس</span>
        </Space>
      }
      extra={
        <Input
          allowClear
          prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
          placeholder="جستجو..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: 220, borderRadius: 8 }}
        />
      }
    >
      <Table
        rowKey="id"
        dataSource={filtered}
        columns={columns}
        loading={loading}
        pagination={{
          pageSize: 8,
          showSizeChanger: true,
          pageSizeOptions: ["8", "12", "50", "100"],
        }}
        scroll={{ x: true }}
        rowClassName={(_, index) => (index % 2 === 0 ? "table-row-even" : "")}
        bordered={false}
      />
    </Card>
  )
}

const mapStateToProps = ({ Accounting }) => ({
  lstInvoices: Accounting.lstInvoices,
  error: Accounting.error,
  success: Accounting.success,
  loading: Accounting.loading,
})

const mapDispatchToProps = dispatch => ({
  onGetInvoices: engId => dispatch(getEngInvoices(engId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceEngList)
